import {SpaceTrSpace, Tr} from "@/i18n/i18n";
import Scene = Phaser.Scene;
import Container = Phaser.GameObjects.Container;
import {BattleLog} from "@/store/arena/types";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {Keys} from "@/constants/key";
import TimeUtils from "@/utils/time-utils";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";
import {Creature, Force, WarriorClass} from "@/store/level/types";
import {ForceUtils} from "@/utils/force-utils";
import {ForceInfoPanel} from "@/scenes.ui/force-info-panel";
import {CreatureUtils} from "@/utils/creature-utils";
import {max} from "lodash";
import PlayerStore from "@/store/player";
import OnceCaller from "@/utils/once-caller";
import {ForceDescription} from "@/store/player/types";
import {ForceUpdateInfo} from "@/store/force/types";
import CreatureStore from "@/store/creature";
import {LevelsInfo} from "@/store/creature/types";

export class BottomForcesPanel extends Container {

    public static instance:BottomForcesPanel | null = null;

    constructor(scene: Scene, canvas: HTMLCanvasElement, creature:Creature, forces:Force[], x:number, y:number,
                showForceRanksManualCallback:(wc:WarriorClass, forcesDescription:ForceDescription, maxRank:number)  => void, getForceInfoCallback: ()=> Promise<ForceUpdateInfo[]>){
        super(scene, x, y);

        BottomForcesPanel.instance = this;

        // let bg = SpriteUtils.addSprite(this.scene, 0, 2, Keys.UI_PROFILE_CHAR_BOTTOM_STRIPE, undefined, CU.CANVAS_WIDTH/CU.S / 27, 1);
        let bg = SpriteUtils.addSprite(this.scene, 0, 2, Keys.UI_PROFILE_CHAR_BOTTOM_STRIPE_2, undefined, 1, 1);
        bg.setOrigin(0.5, 1);
        this.add(bg);

        let stepX = 40;
        let maxInCenter = 9;
        let forcesCountReduced = Math.min(forces.length, maxInCenter);
        let x0 = (forcesCountReduced % 2 == 0 ? -stepX * (forcesCountReduced / 2 - 0.5) : -stepX * (forcesCountReduced - 1) / 2)
                            + (forces.length > maxInCenter ? - stepX * (forces.length - maxInCenter) : 0);
        let y0 = -26;

        forces.forEach((force, index) => {
            if(index == 0){
                let bgGray = SpriteUtils.addSprite(this.scene, x0 + stepX * index, 8, Keys.UI_PROFILE_CHAR_BOTTOM_STRIPE_GRAY);
                bgGray.setOrigin(0.5, 1);
                bgGray.alpha = 1;
                this.add(bgGray);
            }

            let image = SpriteUtils.addSprite(this.scene, x0 + stepX * index, y0,
                // CreatureUtils.getForceAtlasLarge(force.warriorClass), CreatureUtils.getLargeForceIcon(force.warriorClass, true), 0.37, 0.37);
                CreatureUtils.getForceAtlasSemiLarge(force.warriorClass), CreatureUtils.getLargeForceIcon(force.warriorClass, true), 0.74, 0.74);
            this.add(image);

            image.setInteractive().on('pointerup', async () => {

                const forceInfos = await getForceInfoCallback();
                let maxRank = forceInfos.filter(fi => fi.warriorClass == force.warriorClass).map(fi => fi.maxLevel).shift();

                // let maxRank = 10;
                if(!maxRank){
                    await CreatureStore.fetchLevelsInfo(creature.id).then((li: LevelsInfo) => {
                        maxRank = li.levels.length;
                    });
                }

                if(ForceInfoPanel.instance != null){
                    ForceInfoPanel.instance.destroy();
                }

                let desc = PlayerStore.GET_FORCE_DESCRIPTION(force.warriorClass);
                if(desc == undefined){
                    PlayerStore.getForceDescription(force.warriorClass).then((forceDescription) => {
                        scene.add.existing(new ForceInfoPanel(scene, canvas, force, maxRank!, image.x + x, image.getTopCenter().y!+ y - 26*CU.S, forceDescription, index == 0, showForceRanksManualCallback));
                    });
                } else {
                    scene.time.delayedCall(10, () => {
                        scene.add.existing(new ForceInfoPanel(scene, canvas, force, maxRank!, image.x + x, image.getTopCenter().y! + y - 26*CU.S, desc!, index == 0, showForceRanksManualCallback));
                    });
                }

            });
        });

    }

}
